export default __webpack_public_path__ + "static/media/element_94.70c3494c.webp";